import styled from "styled-components";
import { space } from "styled-system";

export const Svg = styled.svg`
  ${space}
`;
